import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  setPasswordResendTimestamp,
  getPasswordResendTimestamp,
  canResetPasswordResendTimestamp,
  getFormattedTimeLeftUntilPasswordResendIsPossible
} from 'src/logic/utils';
import * as actions from '../redux/registrationPopupActions';
import moment from 'moment';

class RegistrationInputTimer extends Component {
  componentDidMount() {
    if (!canResetPasswordResendTimestamp()) {
      this.updateIntervalToken = setInterval(this.update, 1000);
    }
  }

  update = () => this.forceUpdate();

  componentWillUnmount() {
    clearInterval(this.updateIntervalToken);
  }

  render() {
    let content;
    if (canResetPasswordResendTimestamp()) {
      content = (
        <button className="link">выслать код</button>
      );
    } else {
      content = getFormattedTimeLeftUntilPasswordResendIsPossible();
    }
    return (
      <div>{content}</div>
    );
  }
}

export default connect(
  (state) => ({...state.registrationPopupReducer}),
  (dispatch) => ({...bindActionCreators(actions, dispatch)})
)(RegistrationInputTimer);



/** WEBPACK FOOTER **
 ** ./src/components/RegistrationPopup/elements/RegistrationInputTimer.jsx
 **/